
  var style = require("icon-maker-loader/.tmp/0f34c3a4-6dce-4c65-b92a-b34bc52b73d4/icon-maker.js");
  var mainClass = style["icon-maker"];
  if (mainClass) {
    module.exports = mainClass + " " + style["icon-maker-gears"];
  } else {
    module.exports = "icon-maker icon-maker-gears";
  }
  


//////////////////
// WEBPACK FOOTER
// ./src/icons/gears.svg
// module id = 541
// module chunks = 5